exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grid .grid-header {\n    margin: 0px 0px !important;\n}\n", ""]);

// exports
